import { AfterViewInit, Component } from '@angular/core';
import { ApplicationFacade, CardsNgrxFacade, CustomerCard, CustomerFacade } from '@ridango/components';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Component({
    selector: 'rwidget-cards-list',
    templateUrl: './cards-list.component.html'
})
export class CardsListComponent implements AfterViewInit {
    assetsPath$ = this.applicationFacade.assetsPath$;
    cards$: Observable<CustomerCard[]> = this.cardsFacade.customerCards$;
    cardsLoaded$: Observable<boolean> = this.cardsFacade.customerCardsLoaded$;

    constructor(
        private applicationFacade: ApplicationFacade,
        private cardsFacade: CardsNgrxFacade,
        private customerFacade: CustomerFacade
    ) {}

    ngAfterViewInit(): void {
        this.actualCustomerLang();
    }

    public actualCustomerLang(): void {
        this.customerFacade.getCustomerProfile();
        const lang = localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE');

        this.customerFacade.profile$
            .pipe(
                filter((customer) => !!customer && customer.lang !== lang),
                take(1)
            )
            .subscribe((customer) => {
                const payload = {
                    name: customer.name,
                    phone: customer.phone,
                    adr_city: customer.adr_city,
                    adr_street_1: customer.adr_street_1,
                    adr_zip: customer.adr_zip,
                    lang
                };
                localStorage.setItem('LOCALIZE_DEFAULT_LANGUAGE', lang);
                this.customerFacade.saveCustomerProfile(payload);
            });
    }
}
